import Card from "../../component/ui/Card";
import { useContext, useEffect, useState } from "react";
import axios from "../../util/axios";
import Spinner from "../../component/ui/Spinner";
import { ClassNames } from "@emotion/react";
import Select from "react-select";
import { toCamelCase } from "../../util/util";
import moment from "moment";
import DataTable from "../../component/DataTable";
import ContentLayout from "../../component/ContentLayout";
import { Context } from "../../component/Context/ErrorContext";

const Landing = () => {
  const { setError } = useContext(Context);
  const [userData, setUserData] = useState([]);
  const [tableColumns, setTableColumns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedDropdown, setSelectedDropdown] = useState<any>("");
  const [dropDownOption, setDropDownOption] = useState([]);

  useEffect(() => {
    axios({
      URL: "/omw/crud",
      method: "GET",
      headers: {
        accept: "*/*",
      },
    })
      .then((res: any) =>
        setDropDownOption(
          res?.data.map((item: any) => ({
            label: toCamelCase(item.tablename.replaceAll("_", " ")),
            value: item.tablename,
          }))
        )
      )
      .catch((e) => setError(e.response?.data?.message)); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectedDropdown !== "") {
      setLoading(true);
      setUserData([]);
      setTableColumns([]);
      getTableData();
      axios({
        method: "GET",
        URL: `/omw/crud/columns/${selectedDropdown.value}`,
      })
        .then((res: any) => {
          // setUserData(res.data.users);
          setTableColumns(
            res?.data?.sort((a: any, b: any) => a.column_order < b.column_order)
          );
        })
        .catch((e) => setError(e.response?.data?.message))
        .finally(() => setLoading(false));
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDropdown]);

  const getTableData = () => {
    if (selectedDropdown) {
      setLoading(true);
      axios({
        method: "GET",
        URL: `/omw/${selectedDropdown.value.replace("omw_", "")}`,
      })
        .then((res: any) => {
          if(res?.data?.status || res?.data?.status === "Success"){
            setUserData(res?.data?.data);
          }else{
            setError("Not Found")
          }
        })
        .catch((e) => setError(e.response?.data?.message))
        .finally(() => setLoading(false));
    }
  };

  const handleSaveUser = async (values: any) => {
    setLoading(true);
    axios({
      method: "PUT",
      URL: `/omw/${selectedDropdown.value.replace("omw_", "")}/${values.id}`,
      data: { ...values, updated_by: "omw_frontend", updated_dt: moment() },
    })
      .then((res) => {
        getTableData();
      })
      .catch((e) => setError(e.response?.data?.message))
      .finally(() => setLoading(false));
  };

  const handleCreateUser = async (values: any) => {
    setLoading(true);
    axios({
      method: "POST",
      URL: `/omw/${selectedDropdown.value.replace("omw_", "")}`,
      data: {
        ...values,
        updated_by: "omw_frontend",
        updated_dt: moment(),
        created_by: "omw_frontend",
        created_dt: moment(),
      },
    })
      .then((res) => {
        getTableData();
      })
      .catch((e) => setError(e.response?.data?.message))
      .finally(() => setLoading(false));
  };

  const onDelete = (id: any) => {
    axios({
      method: "DELETE",
      URL: `/omw/${selectedDropdown.value.replace("omw_", "")}/${id}`,
    })
      .then((res) => {
        getTableData();
      })
      .catch((e) => setError(e.response?.data?.message))
      .finally(() => setLoading(false));
  };

  return (
    <ContentLayout className={"items-start"}>
      <div className={"p-4 flex items-center flex-col w-full h-screen"}>
        <div className={"flex w-full self-start items-center"}>
          <p>Select Table Name:&nbsp;</p>
          <Select
            options={dropDownOption}
            onChange={(v) => setSelectedDropdown(v)}
            value={selectedDropdown}
            className={"z-20 w-60"}
          />
        </div>
        {loading && <Spinner />}
        {!loading && userData.length ? (
          <ClassNames>
            {({ css, cx }) => (
              <Card
                className={cx(
                  "p-0 w-full mt-4",
                  css`
                    max-height: calc(100vh - 88px);
                  `
                )}
              >
                <DataTable
                  columns={tableColumns}
                  data={userData}
                  onCreate={handleCreateUser}
                  onEditSave={handleSaveUser}
                  onDelete={onDelete}
                  valueKey={"column_name"}
                  labelKey={"column_comment"}
                  typeKey={"column_type"}
                  enablePagination={true}
                  enableEditing={true}
                  enableSorting={true}
                  createDisplayMode={"modal"}
                  editDisplayMode={"modal"}
                  state={{
                    columnVisibility: { id: false },
                    density: "comfortable",
                    columnPinning: {
                      right: ["mrt-row-actions"],
                    },
                  }}
                  recordIdKey={"id"}
                  hideEditFields={[
                    "id",
                    "created_dt",
                    "created_by",
                    "updated_by",
                    "updated_dt",
                  ]}
                />
              </Card>
            )}
          </ClassNames>
        ) : null}
      </div>
    </ContentLayout>
  );
};

export default Landing;
